//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
export default {
  name: "OrderTable",
  props: [
    "tableClass",
    "bordered",
    "columns",
    "data",
    "title",
    "recordsTotal",
    "loading",
    "canFilter",
    "separator",
    "selection",
    "selected",
  ],
  components: {
    Table,
  },
  data: function () {
    return {
      visibleColumns: this.columns.map((column) => column.name),
      pagination: {
        rowsPerPage: 30,
      },
      sortStatus: Array(this.columns.length).fill(true),
      filterData: Object.assign(
        {},
        Array(this.columns.length)
          .fill({})
          .map((item, index) => ({
            index: index,
            colKey: this.columns[index].name,
            exclude: [""],
          }))
      ),
    };
  },
  methods: {
    fetchRowData: function (index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
};
